import {
  InputLabelText,
  JobDescriptionWrap,
} from '@components/userDocuments/editDocument/UI/pop-ups/jobDescriptionPopup/jdPopupComponents';
import {
  JOB_DESCRIPTION,
  JOB_LOCATION,
  JOB_TITLE,
  ORGANIZATION_NAME,
} from '@components/userDocuments/editDocument/editResume/generateCoverLetter/enums.generateCl';
import { CustomTextarea } from '@components/userDocuments/editDocument/editResume/jobDescriptionPopup';
import { Input } from '@heroui/react';
import { AiJobDescription } from '@components/userDocuments/editDocument/editResume/aiJobDescription';
import { HR, Line, OR } from '@components/common/signInSignUp/newSignIn';
import styled from 'styled-components';
import { Black } from '@styling/theme';
import data from '../../../../../userDocuments/editDocument/UI/pop-ups/jobDescriptionPopup/data';

const StyledOR = styled(OR)`
  color: ${Black};
`;

const JDDataStep = ({
  organizationName,
  handleJDDataChange,
  isShowOrganization,
  jobTitle,
  jobLocation,
  jobDescription,
  setJobData,
}) => {
  const { JDReviewPopup } = data;
  return (
    <>
      <JobDescriptionWrap className="px-[4px] mb-4">
        <AiJobDescription setJobData={setJobData} />
        <div className="py-[8px] desktopSm:py-[8px] desktopMd:py-[8px]">
          <HR>
            <Line />
            <StyledOR>OR</StyledOR>
            <Line />
          </HR>
        </div>
        <InputLabelText>{JDReviewPopup.subHeading}</InputLabelText>
        <div className="grid gap-[12px]">
          <Input
            size="md"
            variant="bordered"
            isRequired
            label={JOB_TITLE}
            placeholder="Copy/paste job title"
            value={jobTitle}
            onChange={handleJDDataChange}
            id="jobTitle"
          />

          {isShowOrganization && (
            <Input
              size="md"
              variant="bordered"
              isRequired
              label={ORGANIZATION_NAME}
              placeholder="Copy/paste organization name"
              value={organizationName}
              onChange={handleJDDataChange}
              id="organizationName"
            />
          )}

          <Input
            size="md"
            variant="bordered"
            label={JOB_LOCATION}
            isRequired
            placeholder="Copy/paste job location"
            value={jobLocation}
            onChange={handleJDDataChange}
            id="jobLocation"
          />

          <CustomTextarea
            size="md"
            variant="bordered"
            label={JOB_DESCRIPTION}
            isRequired
            placeholder="Copy/paste job description"
            value={jobDescription}
            onChange={handleJDDataChange}
            id="jobDescription"
            className="h-[200px] "
            classNames={{
              innerWrapper: 'innerWrapper h-[200px]',
              input: 'input',
              inputWrapper: 'px-[16px] pr-[6px]',
            }}
          />
        </div>
      </JobDescriptionWrap>
    </>
  );
};

export default JDDataStep;
